import { FCC } from '@types';
import { createContext, RefObject, useContext, useRef } from 'react';

export interface DonateButtonState {
  ref: RefObject<HTMLDivElement> | null;
}

export const DonateButtonContext = createContext<DonateButtonState>({} as DonateButtonState);
export const useDonateButtonRef = () => useContext(DonateButtonContext);

export const DonateButtonProvider: FCC = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <DonateButtonContext.Provider
      value={{
        ref,
      }}
    >
      {children}
    </DonateButtonContext.Provider>
  );
};
